<div class="div-breadcrumb my-2">
    <table>
        <tr>
            <td>
                <a class="pointer" href="{{returnAction}}">
                    <div class="d-flex flex-row div-icon">
                        <div class="back-icon">
                            <i class="bi bi-arrow-left pointer"></i>
                        </div>
                        <div class="back-text d-none d-sm-block">{{'back'|translate}}</div>
                    </div>
                </a>
            </td>
            <td>
                <nav class="cd-breadcrumb" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li  *ngFor="let crumb of breadcrumbs; let last = last" class="breadcrumb-item {{!last?'':'active'}}">
                            <a  *ngIf="crumb.url && !last" [routerLink]="crumb.url">{{ crumb.label }}</a>
                            <span *ngIf="!crumb.url || last">{{ crumb.label }}</span>
                        </li>
                    </ol>
                  </nav>   
            

            </td>
        </tr>
    </table>
</div>